import React from "react";

import { Steps } from "antd";
import { UserOutlined, SolutionOutlined, LoadingOutlined, CheckCircleOutlined } from "@ant-design/icons";

import { INVOICE_STATUS_ACCEPTED, INVOICE_STATUS_IN_REVIEW } from "../../../../../config/const";

const { Step } = Steps;

const StepsForm = (props) => (
    <Steps>
        <Step status="process" title="Form" icon={<LoadingOutlined />} />
        <Step status="wait" title="In Review" icon={<UserOutlined />} />
        <Step status="wait" title="Accepted" icon={<CheckCircleOutlined />} />
    </Steps>
);

const StepsInReview = (props) => (
    <Steps>
        <Step status="finish" title="Form" icon={<SolutionOutlined />} />
        <Step status="process" title="In Review" icon={<LoadingOutlined />} />
        <Step status="wait" title="Accepted" icon={<CheckCircleOutlined />} />
    </Steps>
);

const StepsAccepted = (props) => (
    <Steps>
        <Step status="finish" title="Form" icon={<SolutionOutlined />} />
        <Step status="finish" title="In Review" icon={<UserOutlined />} />
        <Step status="finish" title="Accepted" icon={<CheckCircleOutlined />} />
    </Steps>
);

const InvoiceSteps = (props) => {
    if (props.status === INVOICE_STATUS_IN_REVIEW) {
        return <StepsInReview />;
    }

    if (props.status === INVOICE_STATUS_ACCEPTED) {
        return <StepsAccepted />;
    }

    return <StepsForm />;
};

export default InvoiceSteps;
